export default {
  title: 'Многодневные туры и экскурсии',
  subtitle: 'Путешествия в места, которые не посмотреть за день',
  viewAll: 'Посмотреть все туры',
} as const;
